<!-- eslint-disable vue/no-v-html -->
<template>
  <div id="tutorial-view">
    <div class="brandlogo-area bg-lg">
      <div class="brandlogo-area__in">
        <div class="brandlogo-area__logo">
          <img src="../assets/images/plogo_bk.svg" alt="Panasonic" />
        </div>
      </div>
    </div>

    <div class="image-container">
      <img
        v-if="$getI18nImage('tutorial_display_image')"
        :src="$getI18nImage('tutorial_display_image')"
        class="tutorial-display-img"
        alt="tutorial_display_image.png"
      />
      <div v-if="isBrowser" class="language-toggle">
        <LanguageToggle />
      </div>
    </div>

    <div class="tutorial-item-container">
      <div class="tutorial-item">
        <img
          src="../assets/images/tutorial_face.png"
          class="tutorial-item-img"
          alt="tutorial_face.png"
        />
        <div class="tutorial-item-message">{{ $t("tutorial.item.face") }}</div>
      </div>

      <div class="tutorial-item">
        <img
          src="../assets/images/tutorial_makeup.png"
          class="tutorial-item-img"
          alt="tutorial_makeup.png"
        />
        <div class="tutorial-item-message">
          {{ $t("tutorial.item.makeup") }}
        </div>
      </div>

      <div class="tutorial-item">
        <img
          src="../assets/images/tutorial_glasses.png"
          class="tutorial-item-img"
          alt="tutorial_glasses.png"
        />
        <div class="tutorial-item-message">
          {{ $t("tutorial.item.glasses") }}
        </div>
      </div>

      <div class="tutorial-item">
        <img
          src="../assets/images/tutorial_light.png"
          class="tutorial-item-img"
          alt="tutorial_light.png"
        />
        <div
          class="tutorial-item-message"
          v-html="$t('tutorial.item.light')"
        ></div>
      </div>
    </div>

    <div class="tutorial-compatible-container">
      <div
        class="tutorial-compatible tutorial-compatible-top"
        v-html="$t('tutorial.annotation.osBrowser')"
      ></div>
      <div
        class="tutorial-compatible"
        v-html="$t('tutorial.annotation.smartphone')"
      ></div>
    </div>

    <div v-if="isShowAgreeTermsOfUse()" id="terms-of-use-container">
      <label class="terms-of-use-check-box" for="terms-of-use-check">
        <input
          id="terms-of-use-check"
          v-model="isAgreeTermsOfUse"
          type="checkbox"
        />
        <span class="check-text">
          <i18n-t keypath="tutorial.agreement.text" tag="span">
            <template #label1>
              <a
                :href="termsOfUseUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="terms-of-use-url"
              >
                {{ $t("tutorial.agreement.label") }}
              </a>
            </template>
          </i18n-t>
        </span>
      </label>
    </div>
    <button
      type="button"
      :class="startSkinAnalysisButtonClass"
      :disabled="!isAgreeTermsOfUse"
      @click="startSkinAnalysis()"
    >
      <div class="start-skin-analysis-button-text">
        <img
          src="../assets/images/icon_camera_line.png"
          alt="icon_camera_line.png"
        />
        {{ $t("tutorial.snap") }}
      </div>
    </button>
  </div>
</template>

<script>
import consoleController from "../utils/logUtil";
import userAgentUtil from "../utils/userAgentUtil";
import eventLogUtil from "../utils/eventLogUtil";
import constant from "../const";
import LanguageToggle from "@/components/LanguageToggle";
import store from "@/utils/store";

export default {
  components: {
    LanguageToggle,
  },
  data() {
    return {
      // アカウントIDをモバイルアプリから受け取る
      accountId: undefined,
      isBrowser: false,
      // 利用規約のURLを設定 (外部サイトも指定できるように<router-link>は使用しない)
      termsOfUseUrl: "",
      isAgreeTermsOfUse: false,
      // 多言語画像のURL保持
      i18n_tutorial_display_image_png: "",
    };
  },
  computed: {
    startSkinAnalysisButtonClass() {
      if (this.isAgreeTermsOfUse) {
        return "start-skin-analysis-button button-agreed";
      }
      return "start-skin-analysis-button button-not-agreed";
    },
  },
  watch: {
    // 言語変更を監視
    $currentLocale(newLocale) {
      this.loadImages();

      // 利用規約のリンク先変更
      //  この時点で$route.queryが書き換わっていない可能性があるので、ここで再構成する
      const newQuery = { ...this.$route.query };
      if (newLocale === constant.DEFAULT_LOCALE) {
        delete newQuery.lang;
      } else {
        newQuery.lang = store.getUrlLang(newLocale);
      }
      this.termsOfUseUrl = this.$router.resolve({
        name: "TermsOfUse",
        query: newQuery,
      }).href;
    },
  },
  created() {},
  mounted() {
    if (userAgentUtil.isNotMobileBrowser()) {
      // 非対応端末の案内画面を表示
      consoleController("log", "is not mobile browser");
      this.$router.replace({
        name: "Unsupported",
      });
    }

    // 初回画像読み込み
    this.loadImages();

    if (this.$route.query.accountId) {
      this.accountId = this.$route.query.accountId;
    }
    // アクセス元(アプリ or ブラウザ)を判別
    if (
      this.accountId === undefined ||
      this.accountId === constant.GUEST_ACCOUNT_ID
    ) {
      this.isBrowser = true;
    }
    this.termsOfUseUrl = this.$router.resolve({
      name: "TermsOfUse",
      query: this.$route.query,
    }).href;
    this.registerViewedPageEvent();
    // DEBUG: デバッグ用のアカウントID
    // this.accountId = "c1eede03-1954-4f6a-8178-46632235735d";
  },
  methods: {
    isShowAgreeTermsOfUse() {
      if (!this.accountId) {
        return true;
      }
      this.isAgreeTermsOfUse = true;
      return false;
    },
    startSkinAnalysis() {
      this.registerClickedAnalysisStartEvent();
      if (!this.accountId) {
        this.accountId = constant.GUEST_ACCOUNT_ID;
      }
      this.$router.replace({
        name: "SkinAnalysis",
        query: { accountId: this.accountId },
      });
    },
    // ページ表示のイベントログ登録
    registerViewedPageEvent() {
      if (
        this.accountId !== undefined &&
        this.accountId !== constant.GUEST_ACCOUNT_ID
      ) {
        const screenId =
          eventLogUtil.getScreenIdList().skinAnalysisBrowserTutorialAppUser;
        const eventData = {
          screenId,
        };
        eventLogUtil.registerEvent(
          this.accountId,
          eventLogUtil.getEventCodeList().viewed_page,
          eventData,
        );
      }
    },
    // 撮影ボタン押下時のイベントログ登録
    registerClickedAnalysisStartEvent() {
      if (
        this.accountId !== undefined &&
        this.accountId !== constant.GUEST_ACCOUNT_ID
      ) {
        const screenId =
          eventLogUtil.getScreenIdList().skinAnalysisBrowserTutorialAppUser;
        const eventData = {
          screenId,
        };
        eventLogUtil.registerEvent(
          this.accountId,
          eventLogUtil.getEventCodeList().clicked_analysis_start,
          eventData,
        );
      }
    },
    async loadImages() {
      // このページで使用する画像を並列読み込み
      await Promise.all([this.$loadI18nImage("tutorial_display_image")]);
    },
  },
};
</script>

<style scoped>
#tutorial-view {
  margin: 0px;
  padding: 0px;
  width: 100vw;
  min-height: 100svh;
  overflow: hidden; /* スクロールさせない */
}

.image-container {
  position: relative;
  height: 220px;
  width: 100vw;
  text-align: center;
  background-color: #f2f2f2;
  margin-top: -5px;
}

.tutorial-display-img {
  height: 220px;
  opacity: 1;
}

.tips-container {
  position: relative;
  height: 44px;
  width: 100vw;
  margin-top: 8px;
}

.icon-tips-img {
  position: absolute;
  width: 44px;
  height: 44px;
  left: calc(50% - 120px);
}

.tips-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  text-align: center;
  font: normal normal medium 16px/24px Noto Sans JP;
  letter-spacing: 0px;
  color: #000000e6;
  opacity: 1;
}

.tutorial-item-container {
  margin-top: 12px;
  display: grid;
  grid-template-columns: 158px 158px;
  grid-template-rows: 46px 46px;
  gap: 8px;
  justify-content: center;
}

.tutorial-item {
  display: flex;
  justify-content: space-between;
  width: 158px;
  height: 46px;
  align-items: center;

  border: 1px solid #00000099;
  border-radius: 8px;
  opacity: 1;
}

.tutorial-item-img {
  width: 32px;
  height: 32px;
  margin: 8px;
  opacity: 1;
}

.tutorial-item-message {
  width: 102px;
  margin-left: 10px;
  text-align: left;
  font: normal normal 500 12px/13px Noto Sans JP;
  letter-spacing: 0px;
  color: #000000e6;
  opacity: 1;
}

.tutorial-compatible-container {
  line-height: 0;
}
.tutorial-compatible-top {
  margin-top: 10px;
}
.tutorial-compatible {
  display: inline-block;
  text-align: left;
  font: normal normal normal 10px/14px Noto Sans JP;
  letter-spacing: 0px;
  color: #000000e6;
  opacity: 0.6;
}

#terms-of-use-container {
  margin-top: 15px;
  display: inline-block;
  text-align: center;
}

/* カスタムチェックボックス */
.terms-of-use-check-box input {
  display: none; /* デフォルトのチェックボックスを非表示 */
}
.terms-of-use-check-box input + .check-text::before {
  background-image: url("../assets/images/checkbox_off.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  content: "";
  height: 30px;
  position: relative;
  width: 30px;
  margin-right: 5px;
}
.terms-of-use-check-box input:checked + .check-text::before {
  background-image: url("../assets/images/checkbox_on.png");
}
.check-text {
  /* チェックボックスとテキストの上下を中央に */
  align-items: center;
  display: flex;
}

.start-skin-analysis-button {
  margin-top: 15px;
  width: 343px;
  height: 52px;
}

.start-skin-analysis-button-text {
  display: flex;
  justify-content: center;
  vertical-align: middle;
}

.start-skin-analysis-button-text img {
  width: 24px;
  height: 24px;
  margin-right: 2px;
}

.button-agreed {
  text-align: center;
  font: normal normal normal 16px/24px Noto Sans JP;
  letter-spacing: 0px;
  color: #ffffffe6;
  background: #333333 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 8px;
  opacity: 1;
  cursor: pointer;
}

.button-not-agreed {
  font: normal normal normal 16px/24px Noto Sans JP;
  letter-spacing: 0px;
  color: #ffffffe6;
  background: #aaaaaa 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 8px;
  border: none;
  opacity: 1;
  cursor: not-allowed;
}

/* ヘッダー */
.brandlogo-area.bg-lg {
  background-color: #f2f2f2;
}
.brandlogo-area__in {
  max-width: 1280px;
  margin: auto;
  display: flex;
  align-items: center;
  height: 42px;
}
.brandlogo-area__logo img {
  max-width: 100%;
  height: 36px;
  display: block;
}

@media (min-width: 981px) {
  .brandlogo-area {
    padding-inline: 20px;
  }
}
@media (max-width: 980px) {
  .brandlogo-area {
    padding-inline: 15px;
  }
}

.language-toggle {
  position: absolute;
  top: 0;
  left: 16px;
  z-index: 10;
}
</style>
